import React, { Component } from 'react';
import cn from 'classname';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import includes from 'lodash/includes';
import pick from 'lodash/pick';

import moment from 'moment';
import qs from 'qs';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import Calendar from '../shared/calendar/main';
import Filters from '../shared/filters/main';

import { formatMoney } from '../../../../shared/js/format';

import { selectors, actions } from './';

import prepareWeeks from './prepare-weeks';

import './index.less';

function isRowHidden(item, levels = []) {
	switch (item.type) {
		case 'general':
			return false;
		case 'region':
			return !(levels.includes(null));
		case 'country':
			return !(levels.includes(null) && levels.includes(item.region));
		case 'affiliate':
			return !(levels.includes(null) && levels.includes(item.region) && levels.includes(item.country));
	}
}

function percentageDiff(a, b) {
	const percent = a === b ? 0 : a === 0 ? 100 : (b / a - 1) * 100;
	return (percent >= 0 ? '+' : '−') + Math.round(Math.abs(percent)) + '%';
}

class Main extends Component {
	constructor(props) {
		super(props);

		this.state = {
			levels: {},
			sorting: {}
		};

		this.toggleLevel = this.toggleLevel.bind(this);
	}

	toggleLevel(key, id) {
		this.setState((state) => {
			const list = state.levels[key] || [];
			return {
				levels: {
					...state.levels,
					[key]: !list.includes(id) ? list.concat(id) : (!id ? [] : list.filter((i) => i !== id))
				}
			};
		});
	}

	sort(index) {
		this.setState((state) => {
			const isSameColumn = state.sorting.index === index;

			return {
				...state,
				sorting: isSameColumn && state.sorting.direction === 'asc' ? {} : {
					index,
					direction: isSameColumn ? !state.sorting.direction ? 'desc' : 'asc' : 'desc'
				}
			};
		});
	}

	renderList(name, list, key, isPercentNeeded = true) {
		const levels = this.state.levels;

		return list[0].data.map((item, i) => (
			<tr
				className={cn(`level-${item.type}`, { hidden: isRowHidden(item, levels[key]) })}
				key={i}
			>
				<td className='sticky'>
					{item.type === 'general' && (
						<button onClick={() => this.toggleLevel(key, null)}>
							<span>{includes(levels[key], null) ? '—' : '+'}</span>{name}
						</button>
					)}
					{item.type === 'region' && (
						<button onClick={() => this.toggleLevel(key, item.region)}>
							<span>{includes(levels[key], item.region) ? '—' : '+'}</span>{item.region.toUpperCase()}
						</button>
					)}
					{item.type === 'country' && (
						<button onClick={() => this.toggleLevel(key, item.country)}>
							<span>{includes(levels[key], item.country) ? '—' : '+'}</span>{item.country}
						</button>
					)}
					{item.type === 'affiliate' && (
						<div>
							{item.affiliate}
						</div>
					)}
				</td>
				{list.slice(1).map((w, j) => {
					const item = w.data[i];

					const percent = isPercentNeeded ? percentageDiff(list[j].data[i].value, item.value) : undefined;

					const text = `${formatMoney(item.value)} ${!percent ? '' : `(${percent})`}`;

					return (
						<td key={j}>
							{!(['stops', 'decreases'].includes(key) && ['country', 'affiliate'].includes(item.type)) ? text : (
								<Link
									className='weekly-report-link'
									to={`/v2/traffic-alerts/link?${qs.stringify({
										affiliate: item.affiliate || undefined,
										country: item.country,
										alert: key === 'stops' ? 'stopped' : 'volumes-decreased',
										range: [
											moment(w.week).format(),
											moment(w.week).endOf('week').format()
										]
									})}`}
									target='_blank'
								>
									{text}
								</Link>
							)}
						</td>
					);
				})}
			</tr>
		));
	}

	renderAccruals(level, name, list, getter) {
		const isOpened = includes(this.state.levels.accruals, true);

		return (
			<tr className={cn(`level${level}`, { hidden: level !== 1 && !isOpened })}>
				<td className='sticky'>
					{level === 1 ? (
						<button onClick={() => this.toggleLevel('accruals', true)}>
							<span>{isOpened ? '—' : '+'}</span>{name}
						</button>
					) : (
						<div>{name}</div>
					)}
				</td>

				{list.map((a, i) => (
					<td key={i}>{formatMoney(getter(a))}$</td>
				))}
			</tr>
		);
	}

	render() {
		const { intl, filters, calendar, data, ...props } = this.props;

		const sorting = this.state.sorting;

		const leads = prepareWeeks(data.leads, sorting);
		const terms = prepareWeeks(data.terms, sorting);
		const bumps = prepareWeeks(data.bumps, sorting);
		const stops = prepareWeeks(data.stops, sorting);
		const decreases = prepareWeeks(data.decreases, sorting);

		return (
			<div className='weekly-report'>
				<div className='weekly-report-actions'>
					<div className='weekly-report-filters clearfix'>
						<Filters
							intl={intl} {...filters} filters={filters} // for crutch support
						/>
					</div>
					<Calendar
						intl={intl}
						{...calendar}
						ranges={pick(calendar.ranges, ['This week', 'Last week'])}
						onInit={calendar.calendarInit}
						onToggle={calendar.calendarToggle}
						onChange={(date, onApply) => {
							if (calendar.tmpSelectCount === 1) {
								date.startDate.startOf('week');
								date.endDate.endOf('week');
							}
							calendar.calendarChange(date, onApply);
						}}
						onApply={calendar.calendarApply}
					/>
					<button
						className='ui-btn ui-btn-primary'
						onClick={props.apply}
					>
						{intl('Apply')}
					</button>
					<button
						className='ui-btn ui-btn-secondary ui-icon-clear'
						onClick={props.clear}
					/>
				</div>

				<div className='weekly-report-table-wrapper'>
					<table>
						<thead>
							<tr>
								<th className='sticky' />

								{data.weeks.map((week, i) => (
									<th
										className='weekly-report-sorting'
										onClick={() => this.sort(i)}
										key={week}
									>
										<span className={cn(sorting.index === i && sorting.direction)}>
											{week.format('DD.MM.YY')} - {week.clone().add(1, 'week').subtract(1, 'ms').format('DD.MM.YY')}
										</span>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{this.renderList(intl('Лидов'), leads, 'leads')}
							{this.renderList(intl('Предложений'), terms, 'terms')}
							{this.renderList(intl('Успешных предложений'), bumps, 'bumps')}

							{this.renderList(intl('Стоп трафика'), stops, 'stops', false)}
							{this.renderList(intl('Упали объёмы'), decreases, 'decreases', false)}

							{this.renderAccruals(1, intl('Доначисления'), data.accruals, (a) => a.guarant + a.manual)}
							{this.renderAccruals(2, intl('Гаранты'), data.accruals, (a) => a.guarant)}
							{this.renderAccruals(2, intl('Доапрувы'), data.accruals, (a) => a.manual)}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
	withPageContainer(withIntl(Main), { name: 'Weekly report' })
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/weekly-report/main.js